import classNames from 'classnames';
import { FC } from 'react';

import { AuthEntryPoint } from '../../features/auth/types';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { ButtonLocation } from '../../types/Subscriptions';
import { GeneralSubscription } from '../GeneralSubscription';
import { Image } from '../Image';

interface SubscriptionBannerProps {
  alignMd?: 'start' | 'center' | 'end';
  buttonLocation: ButtonLocation;
  image?: string;
  source: AuthEntryPoint;
  subtitle: string;
  title: string;
}

export const SubscriptionBanner: FC<SubscriptionBannerProps> = ({
  alignMd = 'end',
  buttonLocation,
  image,
  source,
  subtitle,
  title,
}) => {
  const mobile = useMediaQuery('sm');

  return (
    <div className="theme-dark relative overflow-hidden rounded-sm bg-neutral-6">
      {image && (
        <div className="absolute inset-0 top-auto">
          <Image alt={title} src={image} />
        </div>
      )}
      <div
        className={classNames(
          'relative flex flex-col justify-end bg-gradient-to-t from-neutral-6 via-neutral-6/90 py-18 md:justify-center md:bg-gradient-to-l',
          {
            'md:items-center': alignMd === 'center',
            'md:items-start': alignMd === 'start',
            'md:items-end': alignMd === 'end',
          },
        )}
      >
        <div className="p-6 md:w-1/2 md:pl-0">
          <div className="mx-auto flex max-w-md flex-col items-center justify-center">
            <h2 className="w-full text-balance text-center text-md font-bold text-white lg:mb-3 lg:text-lg">
              {title}
            </h2>
            <p className="mb-4 text-balance text-center text-white lg:mb-8">
              {subtitle}
            </p>
            <GeneralSubscription
              analyticsButtonLocation={buttonLocation}
              dark
              inlineInputs={!mobile}
              isFullWidth={mobile}
              legalsDefault
              source={source}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
